import publikationsTyp from '@/schema/PublikationsTyp'

import ListFilterFieldsGeneric from './ListFilterFieldsGeneric'
let Filter = ListFilterFieldsGeneric('Publikation')

export default {
  label: 'Publikation',
  route: 'publikation',
  fields: [
    Filter.ReferenceByMultiValueSearchRep('organisationseinheit', 'sitemap', 'organisationseinheit'),
    Filter.kumuliert(),
    {
      label: 'Publikation.list.filter.veroeffentlichungsJahr',
      field: 'veroeffentlichungsJahr',
      type: Number,
      icon: 'calendar-o'
    },
    {
      label: 'Publikation.list.filter.beteiligte',
      field: 'beteiligte',
      cardinality: 'single',
      icon: 'user',
      type: 'object',
      schema: {
        route: 'abstractperson',
        className: 'abstractPerson'
      },
      finder: {
        name: 'byMultiValueSearchRep',
        multiValue: true,
        minLength: 3
      }
    },
    Filter.String('titelPublikation'),
    publikationsTyp,
    Filter.Reference(
      'author',
      'user',
      'abstractPerson',
      {
        name: 'byMultiValueSearchRep',
        multiValue: true,
        minLength: 4
      }
    ),
    {
      label: 'Publikation.list.filter.herausgeber',
      field: 'herausgeber',
      cardinality: 'single',
      icon: 'user',
      type: 'object',
      schema: {
        route: 'abstractperson',
        className: 'abstractPerson'
      },
      finder: {
        name: 'byMultiValueSearchRep',
        multiValue: true,
        minLength: 3
      }
    },
    {
      label: 'Publikation.list.filter.freieID',
      field: 'freieID',
      type: 'string'
    },
    {
      label: 'Publikation.list.filter.validiert',
      field: 'validiert',
      type: 'select',
      translatable: true,
      values: [
        {
          value: 'TRUE',
          label: 'PublikationValidiert.TRUE'
        },
        {
          value: 'FALSE',
          label: 'PublikationValidiert.FALSE'
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/PublikationFilter.js